import { createFileRoute } from "@tanstack/react-router"

import { issueTypeGeneralViewStaticData } from "../../../../../../../../views/IssueTypeSettingsGeneralView/constants"
import { IssueTypeSettingsGeneralView } from "../../../../../../../../views/IssueTypeSettingsGeneralView/IssueTypeSettingsGeneralView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general",
)({
	component: IssueTypeSettingsGeneralView,
	staticData: issueTypeGeneralViewStaticData,
})
